// @ts-nocheck
// Attention strip above a live-calls board: long ringing, long hold, long
// queue wait, transfer in flight. Clicking an alert selects that call.
import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { Pill } from '@/features/cti2/team/teamUi';
import type { LiveCallAlert } from '../liveCallsModel';

export default function LiveCallsAlertsBar({ alerts, onPick }: { alerts: LiveCallAlert[]; onPick?: (callId: string) => void }) {
  if (!alerts.length) {
    return (
      <p className="text-[11px] text-muted-foreground">
        No alerts · ring &gt; 8 s, hold &gt; 45 s, queue &gt; 60 s, transfer in progress
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {alerts.map((a) => (
        <button key={a.id} type="button" onClick={() => onPick?.(a.callId)} className="text-left">
          <Pill tone={a.tone}>
            {a.tone === 'crit' ? <AlertTriangle size={11} /> : <Clock size={11} />}
            {a.text}
          </Pill>
        </button>
      ))}
    </div>
  );
}
